var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import invest1 from 'assets/invest_1.png';
import invest2 from 'assets/invest_2.png';
import invest3 from 'assets/invest_3.png';
import styles from '../Header.module.css';
import ModalThankYou from '../../ModalThankYou';
import HeadFormSignUp from './HeadFormSignUp';
import HeaderFormPhone from './HeaderFormPhone';
import HeaderFormInvestment from './HeaderFormInvestment';
var Step;
(function (Step) {
    Step[Step["SIGN_UP"] = 1] = "SIGN_UP";
    Step[Step["PHONE"] = 2] = "PHONE";
    Step[Step["INVESTMENT"] = 3] = "INVESTMENT";
    Step[Step["WAIT_LIST"] = 4] = "WAIT_LIST";
})(Step || (Step = {}));
export default function HeaderForm(_a) {
    var _this = this;
    var top = _a.top, project = _a.project;
    var divRef = useRef(null);
    var _b = useState(top ? 'absolute' : 'unset'), position = _b[0], setPosition = _b[1];
    var _c = useState(Step.SIGN_UP), step = _c[0], setStep = _c[1];
    var _d = useState({ firstName: '', lastName: '', email: '', phone: '', phoneCountry: '' }), data = _d[0], setData = _d[1];
    var _e = useState(0), amount = _e[0], setAmount = _e[1];
    var t = useTranslation().t;
    useEffect(function () {
        var handleScroll = function () {
            if (top && (window.scrollY > (top - 24)) && (window.scrollY > 0)) {
                setPosition('fixed');
            }
            else if (top) {
                setPosition('absolute');
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var onNext = function (newData) { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if (newData) {
                setData(function (curr) { return (__assign(__assign({}, curr), newData)); });
            }
            if (step === Step.SIGN_UP) {
                setStep(Step.PHONE);
            }
            else if (step === Step.PHONE) {
                setStep(Step.INVESTMENT);
            }
            else if (step === Step.INVESTMENT) {
                setStep(Step.WAIT_LIST);
            }
            (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return [2 /*return*/];
        });
    }); };
    if (step === Step.WAIT_LIST) {
        return _jsx(ModalThankYou, { project: project, lead: data, amount: amount });
    }
    return (_jsxs("div", { className: styles['form-container'], style: { position: position, top: (position === 'absolute') ? "calc(".concat(top, "px - 1rem)") : '8rem' }, ref: divRef, children: [_jsx("h2", { children: t("header.form.title") }), _jsx("p", { className: styles.description, children: step === Step.INVESTMENT
                    ? (_jsxs(_Fragment, { children: [t("header.form.description"), " ", _jsxs("b", { children: [[539, 17909].includes(project.id) ? '11 737' : '47 351', "\u20AC"] }), "."] }))
                    : t("header.description") }), _jsxs("form", { className: styles.form, children: [step === Step.SIGN_UP && (_jsx(HeadFormSignUp, { onNext: onNext, project: project })), step === Step.PHONE && (_jsx(HeaderFormPhone, { onNext: onNext, email: data === null || data === void 0 ? void 0 : data.email, firstName: data === null || data === void 0 ? void 0 : data.firstName, lastName: data === null || data === void 0 ? void 0 : data.lastName, project: project })), step === Step.INVESTMENT && (_jsx(HeaderFormInvestment, { onNext: onNext, email: data === null || data === void 0 ? void 0 : data.email, firstName: data === null || data === void 0 ? void 0 : data.firstName, lastName: data === null || data === void 0 ? void 0 : data.lastName, phone: data === null || data === void 0 ? void 0 : data.phone, phoneCountry: data === null || data === void 0 ? void 0 : data.phoneCountry, project: project, amount: amount, setAmount: setAmount }))] }), _jsxs("div", { className: styles['wait-list'], children: [_jsxs("div", { className: styles.row, children: [_jsxs("div", { children: [_jsx("p", { className: styles.label, children: t("header.footer.peoples", { value: [539, 17909].includes(project.id) ? '5' : '25' }) }), _jsx("p", { className: styles.hint, children: t("header.footer.reservations", { value: [539, 17909].includes(project.id) ? '5' : '25' }) })] }), _jsxs("div", { children: [_jsx("p", { className: styles.label, children: t("header.footer.slotLeft", { value: [539, 17909].includes(project.id) ? '30' : '30' }) }), _jsx("p", { className: styles.hint, children: t("header.footer.slotLimited") })] })] }), _jsx("div", { className: styles['progress-bar'], children: _jsx("div", { className: "".concat(styles.progress, " ").concat([539, 17909].includes(project.id) ? styles.other : '') }) }), _jsxs("div", { className: styles['investors-container'], children: [_jsxs("div", { className: styles.investors, children: [_jsx("img", { alt: "Investisseur 1", src: invest1 }), _jsx("img", { alt: "Investisseur 2", src: invest2 }), _jsx("img", { alt: "Investisseur 3", src: invest3 }), _jsxs("div", { className: styles['other-invest'], children: ["+", [539, 17909].includes(project.id) ? '12' : '147'] })] }), _jsx("p", { className: styles['wait-list-number'], children: t("header.footer.peoplesWaiting", { value: [539, 17909].includes(project.id) ? '15' : '150' }) })] })] })] }));
}
